<ng-container>
  <div class="formControl mt">
    <title
      direction="left"
      [style]="{
        'font-size': '16px',
        color: '#3376F6',
        'margin-bottom': '1.5rem',
      }"
    >
      Avez-vous connu une baisse de l'un de vos placements ?
    </title>
    <pr-input-radio
      formControlName="hadInvestmentDecrease"
      direction="column"
      [isDefault]="false"
      columns="2"
      [options]="options1"
      [derrors]="derrors"
    >
    </pr-input-radio>
  </div>
  <div class="formControl mt">
    <title
      direction="left"
      [style]="{
        'font-size': '16px',
        color: '#3376F6',
        'margin-bottom': '1.5rem',
      }"
    >
      Quelle serait votre réaction face à une baisse de l'un de vos placements ?
    </title>
    <pr-input-radio
      formControlName="investmentDecreaseReaction"
      direction="column"
      [isDefault]="false"
      [options]="options2"
      columns="1"
      [derrors]="derrors"
    >
    </pr-input-radio>
  </div>
</ng-container>
